import { render, staticRenderFns } from "./Hometabone.vue?vue&type=template&id=4563e7a2&scoped=true"
import script from "./Hometabone.vue?vue&type=script&lang=js"
export * from "./Hometabone.vue?vue&type=script&lang=js"
import style0 from "./Hometabone.vue?vue&type=style&index=0&id=4563e7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563e7a2",
  null
  
)

export default component.exports